import { getHeaders } from "$utils/utils";
import config from "./config";

const { order_url: url } = config;
const headers = getHeaders("");

export const getIsOrderInAnEDB = async (orderId: string) => {
  try {
    const response = await fetch(`${url}/orders/edb/${orderId}`, {
      method: "GET",
      headers,
    });
    if (!response.ok) {
      return null;
    }
    const res = await response.json();
    return res; // Note: EDB data comes from external API, this endpoint returns empty array
  } catch (error: any) {
    return { error };
  }
};

export const areOrderRefsAlreadyUsed = async (
  orderReferences: string[],
  companyId: string
) => {
  try {
    const data = { orderReferences, companyId };
    const response = await fetch(`${url}/orders/checkReferences`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(
        "An error occurred when checking if references are already used."
      );
    }
    const res = await response.json();
    return res.checks && res.checks.length > 0;
  } catch (error: any) {
    return { error };
  }
};

export const isProductInAnOrder = async (
  productRef: string,
  companyId: string
) => {
  try {
    const body = {
      ref: productRef,
      companyId,
    };
    const response = await fetch(`${url}/orders/products/used`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      return null;
    }
    const res = (await response.json()).isProductUsed;
    return res;
  } catch (error: any) {
    return { error };
  }
};

export const getOrder = async (id: string) => {
  try {
    // Note: Prisma API automatically includes related data, no populate needed
    const response = await fetch(`${url}/orders/${id}`, {
      method: "GET",
      headers,
    });
    if (!response.ok) {
      return null;
    }
    const res = await response.json();
    return res.data;
  } catch (error: any) {
    return { error };
  }
};

// @TODO / @UPGRADE
// When company isn't defined (aka null value) it's seem that the call to /orders/all/null/<providerType> was perfectly intended...
export const getOrders = async (company: string, isTransfer: boolean) => {
  const providerType = isTransfer ? "transfer" : "non-transfer";
  const response = await fetch(`${url}/orders/all/${company}/${providerType}`, {
    method: "GET",
    headers,
  });
  if (!response.ok) {
    return null;
  }
  return response;
};

export const createOrderItem = async (body: any) => {
  try {
    const response = await fetch(`${url}/orders`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      return null;
    }
    const res = await response.json();
    return res;
  } catch (error: any) {
    return { error };
  }
};

export const updateOrderItem = async (id: string, body: any) => {
  try {
    const response = await fetch(`${url}/orders/${id}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      return null;
    }
    const res = await response.json();
    return res;
  } catch (error: any) {
    return { error };
  }
};

export const updateOrderItemByReference = async (
  reference: string,
  body: any
) => {
  try {
    const response = await fetch(
      `${url}/orders/updateByReference/${reference}`,
      {
        method: "PUT",
        headers,
        body: JSON.stringify(body),
      }
    );
    if (!response.ok) {
      return null;
    }
    const res = await response.json();
    return res;
  } catch (error: any) {
    return { error };
  }
};

/**
 *
 * @param query : Prisma format query string (or legacy strapiQuery for backward compatibility)
 * @param toUpdate specify if the file is in the specific format used to update the orders
 */
export const exportOrders = async (
  token: string,
  query: string,
  toUpdate: boolean
) => {
  try {
    const headersWithToken = getHeaders(token);
    // Send as 'query' (Prisma format), gateway will handle backward compatibility
    const response = await fetch(`${url}/export`, {
      method: "POST",
      headers: headersWithToken,
      body: JSON.stringify({ query, toUpdate }),
    });
    if (!response.ok) {
      return null;
    }
    return response;
  } catch (error: any) {
    return { error };
  }
};

export const deleteOrderItem = async (id: string) => {
  try {
    const response = await fetch(`${url}/orders/${id}`, {
      method: "DELETE",
      headers,
    });
    if (!response.ok) {
      return null;
    }
    const res = await response.json();
    return res;
  } catch (error: any) {
    return { error };
  }
};
